<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_toc_1"><span>Author’s Note</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent"><span style=" font-size: 1.17em;">PAMPLONA IS</span> my city, and I’ve tried to portray it to the best of my ability. That said, I may have tweaked a bit of its geography: just made a street shorter or added a restaurant where there isn’t one. The rest is part of a beautiful city, just the way I see it.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0005.vue?b5f51d9a